export default __webpack_public_path__ + "static/media/tufan9.12caca37.jpg";